<template>
    <div class="row mb-3">
        <div class="col-12">
            <h4 class="mt-3 mb-3 text-center">Timeline</h4>
            <div class="row">
                <div class="col-6">
                    <div class="form-floating mb-3">
                        <input type="date" class="form-control" id="startDate"  v-on:change="getTimeline" v-model="startDate">
                        <label for="startDate">Start Date</label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-floating mb-3">
                        <input type="date" class="form-control" id="endDate"  v-on:change="getTimeline" v-model="endDate">
                        <label for="endDate">End Date</label>
                    </div>
                </div>
            </div>
            <highcharts :options="chartOptions"></highcharts>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-12 col-lg-6">
            <h4 class="mt-3 mb-3 text-center">Wettest Days</h4>
            <div class="mb-3" v-if="wettestDays.length">
                <div class="row" v-for="event in wettestDays">
                    <div class="col-9">
                        <div class="progress my-1" style="height: 20px; font-size: 0.8rem">
                            <div class="progress-bar bg-primary" role="progressbar" :style="{ 'width': (event.rainfall/this.dayMax)*100+'%' }">{{ event.date }}</div>
                        </div>
                    </div>
                    <div class="col-3 text-right">{{ event.rainfall }}mm</div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6">
            <h4 class="mt-3 mb-3 text-center">Wettest Months</h4>
            <div class="mb-3" v-if="wettestMonths.length">
                <div class="row" v-for="event in wettestMonths">
                    <div class="col-9">
                        <div class="progress my-1" style="height: 20px; font-size: 0.8rem">
                            <div class="progress-bar bg-primary" role="progressbar" :style="{ 'width': (event.rainfall/this.monthMax)*100+'%' }">{{ event.monthname }} {{ event.year }}</div>
                        </div>
                    </div>
                    <div class="col-3 text-right">{{ event.rainfall }}mm</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'startDate',
        'endDate',
        'wDay',
        'wMonth',
        'wYear',
        'username',
    ],
    data() {
        return {
            dayMax: 100,
            monthMax: 100,
            events: [],
            wettestDays: [],
            wettestMonths: [],
            chartOptions: {
                chart: {
                    type: 'column'
                },
                title: false,
                colors: ['#00303F', '#39603d', '#3c403d', '#a3bcb6'],
                plotOptions: {
                    column: {
                        pointPadding: 0,
                    }
                },
                xAxis: {
                    categories: [],
                     labels: {
                        rotation: -90
                    }
                },
                yAxis: {
                    title: false
                },
                series: [{
                    showInLegend: true,
                    data: [],
                    name: "Daily Rainfall (mm)"
                }]
            }
        };
    },
    methods: {
        getTimeline: function () {
            axios.get("/ajax/dash/" + this.username + "/timeline/?startDate=" + startDate.value + "&endDate=" + endDate.value)
                .then(response => {
                    this.events = response.data.data;
                    this.chartOptions.series[0].data = [];

                    for (const event of this.events) {
                        var index = event.date.indexOf(' ', event.date.indexOf(' ') + 1);
                        this.chartOptions.xAxis.categories.push(event.date.substr(0, index));
                        this.chartOptions.series[0].data.push(Number(event.rainfall));
                    }
                })
        },
        getData: function () {
            axios.get("/ajax/dash/" + this.username + "/wettestdays/")
                .then(response => {
                    this.wettestDays = response.data.data;
                    this.dayMax = this.wettestDays[0]['rainfall'];
                })
            axios.get("/ajax/dash/" + this.username + "/wettestmonths/")
                .then(response => {
                    this.wettestMonths = response.data;
                    this.monthMax = this.wettestMonths[0]['rainfall'];
                })
        }
    },
    mounted() {
        this.getTimeline();
        this.getData();
    }
};
</script>

